import { useQuery, useMutation } from 'react-query';
import { EmpSepecificAttendenceReport } from '@api/EmpSepecificAttendenceReport';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useEmpSpecificAttendenceReport = (onSuccess, onError = onDefaultError) => {
  return useMutation(
    (params) => EmpSepecificAttendenceReport.listReport(params),
    {
      onSuccess,
      onError
    }
  );
};
const useGetAllEmployees = (onSuccess, onError = onDefaultError) => {
  return useQuery('employee-list', EmpSepecificAttendenceReport.employeeListReport, {
    onSuccess,
    onError
  });
};

const useGetAllInactiveEmployees = (onSuccess, onError = onDefaultError) => {
  return useQuery('inactive-employee-list', EmpSepecificAttendenceReport.inactiveEmployeeListReport, {
    onSuccess,
    onError
  });
};

export {
  useEmpSpecificAttendenceReport,
  useGetAllEmployees,
  useGetAllInactiveEmployees
};